// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Part from '@deere/cps-it.warranty-model-factory/lib/part';
import PartsCoverageSearch from '@deere/cps-it.warranty-model-factory/lib/parts-coverage-search';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import {buildDate} from '../../../shared/services/build-date';
import {translate} from '../../../shared/services/translation-service';

const PartsCoverageSearchResults = props => {

    const reportItems = (<div>
        {
            props.report.map(reportItem => {

                const match = props.warranties.find(warranty => reportItem.warranty === warranty.warrantyType.value && reportItem.warrantySubtype === warranty.warrantyItemText);

                const isExpired = match ? match.isExpired : false;

                return (
                    <div
                        className={isExpired ? 'part-coverage-search-results-item disabled' : 'part-coverage-search-results-item'}
                        key={reportItem.warranty + reportItem.warrantySubtype.replace(/ /g, '_')}
                    >
                        <div>
                            {reportItem.warranty}
                            {reportItem.warrantySubtype && <span>{reportItem.warrantySubtype}</span>}
                        </div>
                        <div>{reportItem.coverage}</div>
                        <div>{buildDate(reportItem.effectiveDate)}</div>
                    </div>
                );

            })

        }

    </div>);

    return (
        <div className='part-coverage-search-results'>
            <header>{`${props.part.partNumber} - ${props.part.partDescription}`}</header>

            <div className='part-coverage-search-results-header'>
                <div>{translate('WARRANTY_TYPE')}</div>
                <div>{translate('COVERAGE_DECISION')}</div>
                <div>{translate('DECISION_UPDATED')}</div>
            </div>

            {reportItems}
        </div>
    );

};

PartsCoverageSearchResults.displayName = 'PartsCoverageSearchResults';
PartsCoverageSearchResults.propTypes = {
    part: PropTypes.instanceOf(Part).isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(PartsCoverageSearch)),
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};

export default PartsCoverageSearchResults;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/components/parts-coverage-search-results.js